export default "__VITE_PUBLIC_ASSET__c6e0ec1b__"